export default __webpack_public_path__ + "static/media/3.f949042e.jpg";